<template>
  <div v-if="noError">
    <div v-if="isDropdown">
      <select id="langchanger" @change="switchLang($event.target.value)">
        <option v-for="lang in languages" :value="lang.code" :key="lang.code" :selected="isSelected(lang.code)">
          {{ lang.name }}
        </option>
      </select>
    </div>
    <ul v-else :class="['language-list', { 'd-flex': pipe || slash }]">
      <li
        v-for="(lang, index) in languages"
        :style="langStyle"
        :key="index"
        :class="{ 'd-flex align-items-center': pipe || slash }"
      >
        <span class="pn language-changer handy" @click="switchLang(lang.code)">
          <country-flag v-if="flag" :country="lang && lang.cc.toLowerCase()" size="normal" />
          <span class="lang-name" v-if="!onlyFlag">{{ lang.name }}</span>
        </span>
        <span v-if="slash && index < languages.length - 1" class="separator">/</span>
        <span v-if="pipe && index < languages.length - 1" class="separator">|</span>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * @param LangSwitcher
 *
 * @description Nyelv választó megjelenítése a felületen
 */
import CountryFlag from 'vue-country-flag'
import { LANGUAGE_CODE_RE } from '../../utils/regular-expressions'
import { getCookie, setCookie } from 'tiny-cookie'
import { get } from 'lodash'
import { COOKIE_OPTIONS } from '@/lib/cookies/cookies'

export default {
  name: 'LangSwitcher',
  components: {
    CountryFlag,
  },
  props: {
    langStyle: {
      type: String,
      default: ``,
    },
    isDropdown: {
      type: Boolean,
      default: false,
    },
    flag: {
      type: Boolean,
      default: true,
    },
    onlyFlag: {
      type: Boolean,
      default: false,
    },
    slash: {
      type: Boolean,
      default: false,
    },
    pipe: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      languages: [],
      selectedLanguage: null,
    }
  },
  computed: {
    noError() {
      return !this.languages.hasOwnProperty('error')
    },
  },
  methods: {
    async dotoLang() {
      this.languages = this.$CORE.IntlLanguages
    },
    async switchLang(lang) {
      this.setLangCookie(lang)
      await this.$client.execute({
        operationId: 'LangSwitcher_setUserLang',
        parameters: {
          code: lang,
        },
      })
      window.location.reload()
    },
    setLangCookie(lang) {
      setCookie('language', lang, {
        expires: '1Y',
        ...COOKIE_OPTIONS
      })
      localStorage.removeItem('lscache-getTranslation')
      localStorage.removeItem('lscache-getTranslation-cacheexpiration')
    },
    isSelected(langCode) {
      return langCode === this.selectedLanguage
    },
  },
  created() {
    this.dotoLang()
    this.selectedLanguage = get(this, '$CORE.language.code')
    if (getCookie('language') && getCookie('language') !== this.selectedLanguage) {
      this.setLangCookie(this.selectedLanguage)
    }
    if (typeof this.selectedLanguage === 'string' && this.selectedLanguage.match(LANGUAGE_CODE_RE)) {
      const page = document.querySelector('html')
      page.setAttribute('lang', this.selectedLanguage.substr(0, 2))
    }
  },
}
</script>

<style lang="scss" scoped>
.separator {
  margin: 0 0.5rem;
}
span.language-changer {
  cursor: pointer;
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
}
.language-list li {
  align-items: center;
  padding: 5px 20px !important;
  transition: 0.5s all;
  &:hover {
    background: $color-primary-hover;
  }
}
.lang-name {
  color: #fff;
}
li {
  list-style: none;
}
ul {
  padding: 0px;
}
</style>
